
import {defineComponent} from "vue";

export default defineComponent({
  name: "vue-materialize-tag",
  props: ['tags']
});
